// 统计与转化埋点
//
// · Cloudflare Web Analytics：在 Cloudflare 后台开启，由 Cloudflare 自动注入，无 Cookie，这里不用管
// · 以下第三方代码只有在 Cloudflare Pages「环境变量」里配置了对应 ID 才会加载（ID 是公开的，不是密钥）：
//     VUE_APP_GA4_ID            Google Analytics 4，例如 G-XXXXXXX
//     VUE_APP_GADS_ID           Google Ads 账号，例如 AW-123456789
//     VUE_APP_GADS_LEAD_LABEL   Google Ads「提交表单」转化的标签
//     VUE_APP_X_PIXEL_ID        X(Twitter) Pixel ID
//     VUE_APP_X_LEAD_EVENT_ID   X「提交表单」事件 ID，例如 tw-xxxxx-xxxxx
//     VUE_APP_BAIDU_TONGJI_ID   百度统计站点 ID
// · 欧洲经济区/英国/瑞士访客默认拒绝广告与统计 Cookie（Google Consent Mode v2），点「接受」后才开启

const CFG = {
  ga4: process.env.VUE_APP_GA4_ID || '',
  gads: process.env.VUE_APP_GADS_ID || '',
  gadsLead: process.env.VUE_APP_GADS_LEAD_LABEL || '',
  xPixel: process.env.VUE_APP_X_PIXEL_ID || '',
  xLead: process.env.VUE_APP_X_LEAD_EVENT_ID || '',
  baidu: process.env.VUE_APP_BAIDU_TONGJI_ID || '',
}

export const hasThirdPartyTags = !!(CFG.ga4 || CFG.gads || CFG.xPixel || CFG.baidu)

const EEA = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IS', 'IE', 'IT', 'LV', 'LI', 'LT', 'LU', 'MT', 'NL', 'NO', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB', 'CH']
const CONSENT_KEY = 'musesec-consent'

function loadScript(src) {
  const s = document.createElement('script')
  s.async = true
  s.src = src
  document.head.appendChild(s)
}

export function readConsent() {
  try { return localStorage.getItem(CONSENT_KEY) } catch (e) { return null }
}

let xLoaded = false
let baiduLoaded = false

function loadX() {
  if (!CFG.xPixel || xLoaded) return
  xLoaded = true
  /* eslint-disable */
  !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);},s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='https://static.ads-twitter.com/uwt.js',a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
  /* eslint-enable */
  window.twq('config', CFG.xPixel)
}

function loadBaidu() {
  if (!CFG.baidu || baiduLoaded) return
  baiduLoaded = true
  window._hmt = window._hmt || []
  loadScript('https://hm.baidu.com/hm.js?' + CFG.baidu)
}

export function initTracking() {
  if (CFG.ga4 || CFG.gads) {
    window.dataLayer = window.dataLayer || []
    window.gtag = function () { window.dataLayer.push(arguments) }
    const denied = { ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied', analytics_storage: 'denied' }
    const granted = { ad_storage: 'granted', ad_user_data: 'granted', ad_personalization: 'granted', analytics_storage: 'granted' }
    window.gtag('consent', 'default', { ...denied, region: EEA, wait_for_update: 500 })
    window.gtag('consent', 'default', granted)
    const c = readConsent()
    if (c === 'granted') window.gtag('consent', 'update', granted)
    if (c === 'denied') window.gtag('consent', 'update', denied)
    window.gtag('js', new Date())
    // 单页应用：页面浏览由路由切换时手动上报
    if (CFG.ga4) window.gtag('config', CFG.ga4, { send_page_view: false })
    if (CFG.gads) window.gtag('config', CFG.gads)
    loadScript('https://www.googletagmanager.com/gtag/js?id=' + (CFG.ga4 || CFG.gads))
  }
  // X 和百度没有地区化的同意模式：拒绝过就不加载
  if (readConsent() !== 'denied') { loadX(); loadBaidu() }
}

export function setConsent(granted) {
  try { localStorage.setItem(CONSENT_KEY, granted ? 'granted' : 'denied') } catch (e) { /* ignore */ }
  const v = granted ? 'granted' : 'denied'
  if (window.gtag) window.gtag('consent', 'update', { ad_storage: v, ad_user_data: v, ad_personalization: v, analytics_storage: v })
  if (granted) { loadX(); loadBaidu() }
}

export function trackPageview(path, title) {
  if (window.gtag && CFG.ga4) window.gtag('event', 'page_view', { page_path: path, page_title: title, page_location: location.href })
  if (window._hmt) window._hmt.push(['_trackPageview', path])
}

// 统一事件入口：generate_lead（表单提交成功）、click_emergency、click_cta、usdt_check、switch_language
export function track(name, params = {}) {
  try {
    if (window.gtag) {
      window.gtag('event', name, params)
      if (name === 'generate_lead' && CFG.gads && CFG.gadsLead) {
        window.gtag('event', 'conversion', { send_to: `${CFG.gads}/${CFG.gadsLead}` })
      }
    }
    if (name === 'generate_lead' && window.twq && CFG.xLead) window.twq('event', CFG.xLead, {})
    if (window._hmt) window._hmt.push(['_trackEvent', 'site', name, params.label || ''])
  } catch (e) { /* 统计失败不影响页面 */ }
}
